/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode, useEffect, useRef } from 'react';

import { css, jsx } from '@compiled/react';

import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';

type Props = {
	children: ReactNode;
	close?: () => void;
	selectedTabId?: string | null;
};

export const MoreMenuContents = ({ children, close, selectedTabId }: Props) => {
	const menuContentsRef = useRef<HTMLDivElement>(null);

	const previousSelectedTabId = useRef(selectedTabId);
	useEffect(() => {
		if (selectedTabId !== previousSelectedTabId.current && close) {
			close();
		} else {
			previousSelectedTabId.current = selectedTabId;
		}
	}, [selectedTabId, close]);

	useEffect(() => {
		if (!menuContentsRef.current) {
			return;
		}

		autoScrollForElements({
			element: menuContentsRef.current,
		});
	}, []);

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
		<div
			css={moreMenuContentsStyles}
			ref={menuContentsRef}
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			{children}
		</div>
	);
};

const moreMenuContentsStyles = css({
	maxHeight: '60vh',
	overflowY: 'auto',
	// We need to add some padding in the menu so the drag previews at the top/bottom don't
	// show a scroll wheel when added. We need to use 1px, since any more would introduce whitespace.
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingBlock: '1px',
});
